export const SYSTEM_LOG_LEVEL = 0;